<!-- <form #modal [formGroup]="form"> -->
<div class="modal-header">
    <h2 class="headline m-0" fxFlex="auto">{{"message_with"|translate}} {{translateHelper.localize(companyData?.name)}}</h2>
    <button class="btn-close" aria-label="Close" (click)="bsModalRef.hide()">
    </button>
</div>

<div class="modal-body scroll">
    <ng-container *ngFor="let message of messages;">
        <ng-container *ngIf="message.from===userId">
            <span fxLayoutAlign="center">{{message.timestamp | date : 'short'}}</span>
            <div class=" mb-4" fxLayout="row wrap" fxLayoutAlign="end end">

                <div class="msg-container">{{message.msg}}</div>
            </div>
            <div fxLayoutAlign="end end" *ngIf="message.images?.length > 0"> <img class="img thumbnail" style="height:100px;width:100px" [src]="(message.images[0])? message.images[0].url : ''"></div>
        </ng-container>

        <ng-container *ngIf="message.from!==userId">
            <span fxLayoutAlign="center">{{message.timestamp | date : 'short'}}</span>
            <div class=" mb-4" fxLayoutAlign="start" fxLayout="row">

                <div fxLayoutAlign="start" class="msg-container from"> {{message.msg}} </div>
                <!-- <span >{{message.timestamp | date }}</span> -->

            </div>
            <div fxLayoutAlign="end end" *ngIf="message.images?.length > 0"> <img class="img thumbnail" style="height:100px;width:100px" [src]="(message.images[0])? message.images[0].url : ''"></div>
        </ng-container>
    </ng-container>
</div>

<div class="p-4 bg-app-bar border-t">
    <form [formGroup]="form">
        <div class="text-hint overflow-hidden bg-card ltr:pl-6 rtl:pr-6" fxFlex="auto" fxLayout="row" fxLayoutAlign="start center">
            <input class="form-control card-radius-x1" formControlName="msg" [attr.placeholder]="'type_message'|translate" type="text">
            <button mat-icon-button type="button" (click)="fileInput.click()">
                <mat-icon>photo</mat-icon>
                <input #fileInput type="file" (change)="fileBrowseHandler($event.target.files)" style="display:none;" accept="image/x-png,image/gif,image/jpeg" />
            </button>
            <button [class.text-primary]="form.get('msg').value" [disabled]="!form.get('msg').value" class="ltr:mr-4 rtl:ms-4 ltr:ms-3 rtl:mr-3" mat-icon-button (click)="send()">
                <mat-icon>send</mat-icon>
            </button>
        </div>
    </form>
    <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 mt-2">
        <div *ngFor="let file of files;let i=index">
            <button class="pull-right float-left close" aria-label="Close" (click)="deletePicture(i)">
                <app-icon name="cross-20" size="20"></app-icon>
            </button>
            <img class="img-thumbnail m-2" style="height:100px;width:100px" [src]="file.url" alt="">
        </div>
    </div>
</div>